<div class="roadmap-page" fxLayout="column" style="max-width: 1176px;">
  <ngx-dynamic-hooks [options]="{sanitize: false}" [content]="content"></ngx-dynamic-hooks>
</div>
